let content = {
    id: 1,
    title: '',
    subtitle: '',
    text: '',
    link: '',
  }

  export default content;